import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getCatalogoZonas() {
  const response = await axios.get(`${API_URL}catalogos/zonas`);
  const data = response.data.doc.data;
  return data;
}

export async function addZonas(body: any) {
  const {
    name,
    email,
    hasResponsible,
    first_name,
    father_last_name,
    mother_last_name,
    password,
  } = body;

  let data: any = {
    name,
    email,
    hasResponsible,
    firstName: first_name,
    fatherLastName: father_last_name,
    motherLastName: mother_last_name,
    password,
  };

  Object.keys(data).forEach((key) => {
    if (data[key] === '' || data[key] === null || data[key] === undefined) {
      delete data[key];
    }
  });

  const response = await axios.post(`${API_URL}catalogos/zonas`, data);
  return response;
}

export async function getZonaById(id: number) {
  const response = await axios.get(`${API_URL}catalogos/zonas/${id}`);
  const data = response.data.doc.data;

  const result = {
    id: data.id || 0,
    name: data.name || '',
    email: data.user?.email || '',
    hasResponsible: data.hasResponsible || false,
    first_name: data.user?.first_name || '',
    father_last_name: data.user?.father_last_name || '',
    mother_last_name: data.user?.mother_last_name || '',
  };

  return result;
}

export async function updateZona(body: any) {
  const {
    id,
    name,
    email,
    hasResponsible,
    first_name,
    father_last_name,
    mother_last_name,
    password,
  } = body;

  let data: any = {
    name,
    email,
    hasResponsible,
    firstName: first_name,
    fatherLastName: father_last_name,
    motherLastName: mother_last_name,
    password,
  };

  Object.keys(data).forEach((key) => {
    if (data[key] === '' || data[key] === null || data[key] === undefined) {
      delete data[key];
    }
  });

  const response = await axios.put(`${API_URL}catalogos/zonas/${id}`, data);
  return response;
}

export async function deleteZona(id: number) {
  const response = await axios.delete(`${API_URL}catalogos/zonas/${id}`);
  return response;
}
